module.exports = __webpack_public_path__ + "img/notify-icon-warn.1e5488a5.svg";